var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.3125C6.65012 2.3125 2.3125 6.65168 2.3125 12C2.3125 17.3514 6.65012 21.6875 12 21.6875C17.3499 21.6875 21.6875 17.3514 21.6875 12C21.6875 6.65168 17.3499 2.3125 12 2.3125ZM12 6.60938C12.9061 6.60938 13.6406 7.34391 13.6406 8.25C13.6406 9.15609 12.9061 9.89062 12 9.89062C11.0939 9.89062 10.3594 9.15609 10.3594 8.25C10.3594 7.34391 11.0939 6.60938 12 6.60938ZM14.1875 16.5312C14.1875 16.7901 13.9776 17 13.7188 17H10.2812C10.0224 17 9.8125 16.7901 9.8125 16.5312V15.5938C9.8125 15.3349 10.0224 15.125 10.2812 15.125H10.75V12.625H10.2812C10.0224 12.625 9.8125 12.4151 9.8125 12.1562V11.2188C9.8125 10.9599 10.0224 10.75 10.2812 10.75H12.7812C13.0401 10.75 13.25 10.9599 13.25 11.2188V15.125H13.7188C13.9776 15.125 14.1875 15.3349 14.1875 15.5938V16.5312Z",
    fill: "#0071BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e298ffdb.svg";
export { ForwardRef as ReactComponent };